export default "__VITE_ASSET__dNRSxs1x__"